import { CLEAR_USER, SET_USER_INFO, SET_SHOW_MENU, SET_FORGOT_EMAIL } from '../actions/user'

const initialState = {
  userInfo: false,
  showMenu: true,
  forgotEmail: false,
};

export default function User(state = initialState, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.userInfo,
      };
    case SET_SHOW_MENU:
      return {
        ...state,
        showMenu: action.showMenu,
      };
    case SET_FORGOT_EMAIL:
      return {
        ...state,
        forgotEmail: action.forgotEmail,
      };
    case CLEAR_USER:
      return Object.assign({
        userInfo: false,
        showMenu: true,
        forgotEmail: false,
      })
    default:
      return state;
  }
}
